import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getViewReferrals = (params) => {
    return axios.get(`${backendHost}/api/admin/referrals/view`, {params});
};

export {
    getViewReferrals
}